module.exports = __webpack_public_path__ + "img/Fried chicken Icon - charcoal.9bca3953.svg";